import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import './FiltrosTrens.css';

/**
 * @param {{ value: string, label: string }[]} linhas
 * @param {{ value: string, label: string }[]} statusList
 * @param {boolean} mostrarSemOpcoes  - exibe "Sem Linha" / "Sem Status" (usado em Alocações)
 * @param {boolean} linhaDesabilitada - trava o select de Linha (usado para Operadores)
 */
export default function FiltrosTrens({
    linhas,
    statusList,
    filtroLinha,
    setFiltroLinha,
    filtroStatus,
    setFiltroStatus,
    mostrarSemOpcoes = false,
    linhaDesabilitada = false,
}) {
    return (
        <Box className="filtros-trens">
            <FormControl size="small" className="filtros-trens__form-linha">
                <InputLabel className="filtros-trens__label" shrink>
                    Linha
                </InputLabel>
                <Select
                    displayEmpty
                    notched
                    className="filtros-trens__select"
                    value={linhas.some(l => l.value === filtroLinha) || mostrarSemOpcoes ? (filtroLinha || '') : ''}
                    label="Linha"
                    onChange={(e) => setFiltroLinha(e.target.value || null)}
                    disabled={linhaDesabilitada}
                >
                    <MenuItem value=""><em>Todas</em></MenuItem>
                    {mostrarSemOpcoes && <MenuItem value="semLinha"><em>Sem Linha</em></MenuItem>}
                    {linhas.map((l) => (
                        <MenuItem key={l.value} value={l.value}>{l.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl size="small" className="filtros-trens__form-status">
                <InputLabel className="filtros-trens__label" shrink>
                    Status
                </InputLabel>
                <Select
                    displayEmpty
                    notched
                    className="filtros-trens__select"
                    value={statusList.some(s => s.value === filtroStatus) || mostrarSemOpcoes ? (filtroStatus || '') : ''}
                    label="Status"
                    onChange={(e) => setFiltroStatus(e.target.value || null)}
                >
                    <MenuItem value=""><em>Todos</em></MenuItem>
                    {statusList.map((s) => (
                        <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
